(function() {
  angular.module('cfn').directive('dHighchartsWrapper', dHighchartsWrapper);

  dHighchartsWrapper.$inject = ['i18nFilter', '$rootScope'];

  function dHighchartsWrapper(i18nFilter, $rootScope, EVENT_CHART_RESIZE) {
    $rootScope.$on('$localeChangeSuccess', i18nHighcharts);

    function i18nHighcharts() {
      if (window.Highcharts) {
        Highcharts.setOptions({
          lang: {
            months: [
              i18nFilter('fe.common.month.jan'),
              i18nFilter('fe.common.month.feb'),
              i18nFilter('fe.common.month.mar'),
              i18nFilter('fe.common.month.apr'),
              i18nFilter('fe.common.month.may'),
              i18nFilter('fe.common.month.jun'),
              i18nFilter('fe.common.month.jul'),
              i18nFilter('fe.common.month.aug'),
              i18nFilter('fe.common.month.sep'),
              i18nFilter('fe.common.month.oct'),
              i18nFilter('fe.common.month.nov'),
              i18nFilter('fe.common.month.dec')
            ],
            weekdays: [
              i18nFilter('fe.common.day.sun'),
              i18nFilter('fe.common.day.mon'),
              i18nFilter('fe.common.day.tue'),
              i18nFilter('fe.common.day.wen'),
              i18nFilter('fe.common.day.thu'),
              i18nFilter('fe.common.day.fri'),
              i18nFilter('fe.common.day.sat')
            ],
            shortMonths: [
              i18nFilter('fe.common.month.jan.short'),
              i18nFilter('fe.common.month.feb.short'),
              i18nFilter('fe.common.month.mar.short'),
              i18nFilter('fe.common.month.apr.short'),
              i18nFilter('fe.common.month.may.short'),
              i18nFilter('fe.common.month.jun.short'),
              i18nFilter('fe.common.month.jul.short'),
              i18nFilter('fe.common.month.aug.short'),
              i18nFilter('fe.common.month.sep.short'),
              i18nFilter('fe.common.month.oct.short'),
              i18nFilter('fe.common.month.nov.short'),
              i18nFilter('fe.common.month.dec.short')
            ],
            resetZoom: i18nFilter('fe.charts.reset.zoom'),
            resetZoomTitle: i18nFilter('fe.charts.reset.zoom')
          }
        });
      }
    }

    return {
      restrict: 'E',
      scope: {
        configdata: '='
      },
      template: '<div style="display: block" class="full-height"></div>',
      link: function(scope, element, attrs) {
        var chartInstance;

        scope.$watch(
          'configdata',
          function(configdata, oldConfigdata) {
            if (_.isUndefined(configdata) || _.isNull(configdata)) return;

            // check whether config is stored in a subobject .highcharts or directly in configdata
            var config = _.isObject(configdata.highcharts)
              ? configdata.highcharts
              : configdata;

            chartInstance = makeChart(element, chartInstance, config);
            var delayedReflow = function() {
              if (
                chartInstance &&
                $(chartInstance.renderToClone || chartInstance.renderTo).width()
              ) {
                chartInstance.reflow();
              } else {
                setTimeout(delayedReflow, 0);
              }
            };
            setTimeout(delayedReflow, 0);
          },
          true
        );

        scope.$on('$destroy', function() {
          destroyChart(chartInstance);
          chartInstance = undefined;
        });

        scope.$on(EVENT_CHART_RESIZE, function() {
          setTimeout(function() {
            if (chartInstance) chartInstance.reflow();
          }, 0);
        });
      }
    };

    function makeChart(element, chart, configdata) {
      if (!window.Highcharts) {
        return;
      }

      i18nHighcharts()
      var confCopy = $.extend(true, {}, configdata);

      if (!_.isObject(configdata)) {
        return;
      }

      destroyChart(chart);

      confCopy.chart = confCopy.chart || {};
      confCopy.chart.renderTo = element[0].children[0];

      return new Highcharts.Chart(confCopy);
    }

    function destroyChart(chart) {
      if (chart) {
        chart.destroy();
      }
    }
  }
})();
